import { render, staticRenderFns } from "./FunFastSimpleSlider.vue?vue&type=template&id=bfdf0156&"
import script from "./FunFastSimpleSlider.vue?vue&type=script&lang=js&"
export * from "./FunFastSimpleSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports